type LocaleType = 'zh-CN' | 'en' // 神经病， 读不到全局的types  -  global.d.ts
export const setHtmlPageLang = (locale: LocaleType) => {
  document.querySelector('html')?.setAttribute('lang', locale)
}
